import { render, staticRenderFns } from "./SelectRelatedArticle.vue?vue&type=template&id=6fe2fe2e"
import script from "./SelectRelatedArticle.vue?vue&type=script&lang=ts"
export * from "./SelectRelatedArticle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports